__turbopack_context__.v({
  "inlineCode": "InlineCode-module-scss-module__HcyN7a__inlineCode",
});
